import { render, staticRenderFns } from "./ProjectInfo.vue?vue&type=template&id=9906dab2"
import script from "./ProjectInfo.vue?vue&type=script&lang=ts"
export * from "./ProjectInfo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9906dab2')) {
      api.createRecord('9906dab2', component.options)
    } else {
      api.reload('9906dab2', component.options)
    }
    module.hot.accept("./ProjectInfo.vue?vue&type=template&id=9906dab2", function () {
      api.rerender('9906dab2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/project/ProjectInfo.vue"
export default component.exports